import Vue from "vue";
import Vuex from "vuex";
import { EMAIL, LEAD_ADD_FOLIO, SYSTEM_USER, TOKEN_ID, SUBSCRIPTION, USER_PORTAL, SESSION_ID } from "./types";
import { KeyVaultResponse, TokenValue } from "src/models/responses/keyvault.response.interface";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    leadFolio: "",
    systemUserId: "",
    userId: "",
    email: "",
    token: "",
    expire_date: null,
    sessionId: "",
    suscription: "",
    url_base: "",
    flow_token_apim: "",
    flow_change_password: "",
    flow_create_login: "",
    flow_change_password_request: "",
    flow_loguot: "",
    flow_validate_user: "",
    flow_validate_login: "",
    isPLD: false
  },
  mutations: {
    [LEAD_ADD_FOLIO](state, folio: string) {
      state.leadFolio = folio;
    },
    [SYSTEM_USER](state, id: string) {
      state.systemUserId = id;
    },
    [USER_PORTAL](state, id: string) {
      state.userId = id;
    },
    [EMAIL](state, mail: string) {
      state.email = mail;
    },
    [SESSION_ID](state, session: string) {
      state.sessionId = session;
    },
    [TOKEN_ID](state, token: TokenValue) {
      state.token = token.TOKEN;
      state.expire_date = token.EXPIRE_DATE;
    },
    [SUBSCRIPTION](state, keyvault: KeyVaultResponse) {
      state.suscription = keyvault.Suscription;
      state.url_base = keyvault.URL_APIM;
      state.flow_token_apim = keyvault.FLOW_TOKEN_APIM;
      state.flow_change_password = keyvault.FLOW_CHANGE_PASSWORD;
      state.flow_change_password_request = keyvault.FLOW_CHANGE_PASSWORD_REQUEST;
      state.flow_create_login = keyvault.FLOW_CREATE_LOGIN;
      state.flow_loguot = keyvault.FLOW_LOGOUT;
      state.flow_validate_user = keyvault.FLOW_VALIDATE_USER;
      state.flow_validate_login = keyvault.FLOW_VALIDATE_LOGIN;
    },
    SET_PLD_STATUS(state, status) {
      state.isPLD = status;
    }
  },
  actions: {
    [LEAD_ADD_FOLIO](context, folio: string) {
      context.commit(LEAD_ADD_FOLIO, folio);
    },
    [SYSTEM_USER](context, id: string) {
      context.commit(SYSTEM_USER, id);
    },
    [USER_PORTAL](context, id: string) {
      context.commit(USER_PORTAL, id);
    },
    [EMAIL](context, mail: string) {
      context.commit(EMAIL, mail);
    },
    [SESSION_ID](context, session: string) {
      context.commit(SESSION_ID, session);
    },
    [TOKEN_ID](context, token: TokenValue) {
      context.commit(TOKEN_ID, token);
    },
    [SUBSCRIPTION](context, keyvault: KeyVaultResponse) {
      context.commit(SUBSCRIPTION, keyvault);
    },
    updatePLDStatus({ commit }, status) {
      commit("SET_PLD_STATUS", status);
    }
  },
  getters: {
    getSystemUser(state) {
      return state.systemUserId;
    },
    getUser(state) {
      return state.userId;
    },
    getMail(state) {
      return state.email;
    },
    getSession(state) {
      return state.sessionId;
    },
    getToken(state) {
      return state.token;
    },
    getTokenExpire(state) {
      return state.expire_date;
    },
    getSubscription(state) {
      return state.suscription;
    },
    getUrlBase(state) {
      return state.url_base;
    },
    getFlowTokenApim(state) {
      return state.flow_token_apim;
    },
    getFlowChangePassword(state) {
      return state.flow_change_password;
    },
    getFlowChangePasswordRequest(state) {
      return state.flow_change_password_request;
    },
    getFlowCreateLogin(state) {
      return state.flow_create_login;
    },
    getFlowLogout(state) {
      return state.flow_loguot;
    },
    getFlowValidateUser(state) {
      return state.flow_validate_user;
    },
    getFlowValidateLogin(state) {
      return state.flow_validate_login;
    },
    getPLDStatus: (state) => state.isPLD
  },
  modules: {}
});
